
import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uniqueId } from 'uuid';
import { addImage } from '../../utils/slices/imageSlice';
import { addToElements, setCurrentElementId } from '../../utils/slices/pageSlice';
const ImageElementBar = () => {
    const dispatch = useDispatch();
    const loadedImages = useSelector((store) => store?.image?.loadedImages);
    const [takeInput, setTakeInput] = useState(0);
    const textRef = useRef(null);
    const handleSubmit = () => {
        if (!textRef.current.value) {
            setTakeInput(!takeInput);
            return;
        }
        const newImg = {
            id: uniqueId(),
            src: textRef.current.value,

        }
        dispatch(addImage(newImg));

        setTakeInput(!takeInput);
        textRef.current.value = '';
    }
    const handleAddNewImage = () => {

        setTakeInput(!takeInput);

    }
    const handleAddToElements = (imgId, input) => {

        const newImgObj = {
            id: imgId,
            type: 'image',
            src: input,
            width: '90px',
            height: '90px',
        }

        dispatch(addToElements(newImgObj));
        dispatch(setCurrentElementId(newImgObj.id));


    }

    return (
        <div className='fixed z-15 top-40'>
            <div className='text-center'>
                <button
                    onClick={handleAddNewImage}
                    className='text-center w-[52%] p-4 mx-auto mt-4 mb-8 bg-purple-500 flex rounded-md hover:bg-purple-700'>

                    <p className='text-white font-semibold ml-1'>Add images</p>
                </button>
                {takeInput ?
                    (<div className='flex flex-col'>
                        <input className='p-1 mx-auto text-center placeholder-black' type='text' ref={textRef} placeholder='Enter Image Source' />
                        <button
                            onClick={handleSubmit}
                            className='w-[30%] p-1 my-2 mx-auto border border-gray-200 rounded-md hover:text-white bg-gray-600'>Submit</button>
                    </div>) : <></>}


            </div>

            <div className='w-[240px] flex flex-wrap'>
                {loadedImages.length ? loadedImages?.map((image) => (
                    <div key={image.id} className='flex flex-col ml-1'>

                        <button
                            onClick={() => handleAddToElements(image.id, image.src)}
                            className='w-[80px] h-[70px] border m-1  relative  border-gray-300'>
                            <img className='w-full h-full' src={image.src} alt='img' />
                        </button>

                    </div>
                )) : <></>}




            </div>
        </div>
    )
}

export default ImageElementBar